import { useDispatch, useSelector } from "react-redux";
import {
    setFloatingContainerState,
    setFloatingWindowState,
    setHeaderState,
    setIsTypingContainerState,
    setSendMessageContainerState
} from "../../../features/componentStateSlice.js";
import useRequestData from "../../../hooks/useRequestData.js";

export default function EntryButton() {
    const dispatch = useDispatch();
    const token = useSelector(state => state.session.token);
    const { initializeChat } = useRequestData();

    const handleButtonClick = async (event) => {
        event.preventDefault();
        dispatch(setFloatingContainerState(false));
        dispatch(setFloatingWindowState(true));
        dispatch(setHeaderState(true));
        dispatch(setSendMessageContainerState(true));

        if (!token) {
            dispatch(setIsTypingContainerState(true));
            await initializeChat();
        }
    };

    return (
        <button type="button" onClick={ handleButtonClick } className="entry-button">
        </button>
    );
};
